import type { Option } from "@tento-lona/sheets";
import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { Button } from "@tento-ui/components/button/button";
import { Divider } from "@tento-ui/components/divider";
import { GESTURE_MANAGER } from "@tento-ui/gesture-manager";
import { AngleRightIcon, LonaIcons } from "@tento-ui/ui/icons";
import { EventIcon } from "./event-icon.ts";

@component({
  name: "lona-existing-event-details-going-button",
})
export class GoingButton extends LonaWebComponent {
  #onStatusChange: Option<(status: string) => void> = null;
  #$statusButton: HTMLButtonElement = this.$("status-button");
  #$moreOptions: HTMLButtonElement = this.$("more-options");

  constructor() {
    super();
    this.$("chevron").appendChild(LonaIcons.make(AngleRightIcon));
  }

  static makeWith(
    status: string,
    onStatusChange: (status: string) => void,
  ): GoingButton {
    const $b = GoingButton.make();
    $b.#onStatusChange = onStatusChange;
    $b.updateStatus(status);
    GESTURE_MANAGER.addPointerEvent($b.#$moreOptions, {
      onClick: () => {
        EventIcon.showRsvpStatusList(
          $b.#$moreOptions,
          (newStatus) => {
            $b.#onStatusChange?.(newStatus);
          },
          "event-details",
        );
      },
    });
    return $b;
  }

  updateStatus(status: string): void {
    const statusMap: Readonly<Record<string, string>> = {
      accepted: "Going",
      declined: "Not going",
      tentative: "Maybe",
      needsAction: "Not responded",
    };
    this.#$statusButton.textContent = statusMap[status] ?? "Unknown";
  }

  static $styles: Style.Compat[] = [
    Button.$style,
    Divider.$vr,
    css`
        :host {
          margin-right: 8px;
          position: relative;
        }

        #root {
          border-radius: 8px;
          border: 1px solid var(--divider);
        }

        std-vr {
          margin: 0;
        }

        #status-button {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          --bg-btn-hvr: none;
          cursor: default;
        }

        #more-options {
          padding: 8px;
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
        }

        #more-options svg {
          transform: rotate(90deg);
        }
      `,
  ];
  static $html: Option<HTMLTemplateElement> = html`
    <std-row id=root>
      <button id=status-button>Going</button>
      <std-vr></std-vr>
      <button id=more-options><std-center id=chevron></std-center></button>
    </std-row>
  `;
}
